'use client';

import i18next, {type i18n, type Resource} from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import {initReactI18next} from 'react-i18next';
import {getI18nOptions, langMap, supportedLngs} from './settings';

const onServer = typeof window === 'undefined';

export function initI18next(lng: string, resources?: Resource): i18n {
  if (onServer) {
    const i18nInstance = i18next.createInstance();
    i18nInstance
      .use(initReactI18next)
      .use(resourcesToBackend((language: string) => langMap[language]()))
      .init({
        ...getI18nOptions(),
        lng,
        resources,
        preload: supportedLngs,
      });
    return i18nInstance;
  }

  if (!i18next.isInitialized) {
    i18next
      .use(initReactI18next)
      .use(resourcesToBackend((language: string) => langMap[language]()))
      .init({
        ...getI18nOptions(),
        lng,
        resources,
        preload: [],
      });
  }

  return i18next;
}
